/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherThermometerIcon24Regular = forwardRef('WeatherThermometerIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.75 13.479V8a.75.75 0 0 0-1.5 0v5.479a2.876 2.876 0 1 0 1.5 0ZM12 14.88a1.375 1.375 0 1 0 0 2.75 1.375 1.375 0 0 0 0-2.75Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.75 5.5a4.25 4.25 0 0 1 8.5 0v5.832a6.5 6.5 0 1 1-8.5 0V5.5ZM12 2.75A2.75 2.75 0 0 0 9.25 5.5v6.188a.75.75 0 0 1-.293.594 5 5 0 1 0 6.086 0 .75.75 0 0 1-.293-.595V5.5A2.75 2.75 0 0 0 12 2.75Z" })));
});
